import { ContactInfo } from '@/models';

export interface ContactInfoState {
  contactInfo: ContactInfo | null
}

export const InitialState: ContactInfoState = {
  contactInfo: null
}
